// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faq-items h3[data-v-1d0bd6ea]{font-size:1.5rem;line-height:1.625;margin-bottom:2rem}.faq-items>div[data-v-1d0bd6ea]{margin-bottom:1rem}.faq-items>div h4[data-v-1d0bd6ea]{font-size:1.25rem;line-height:1.75}.faq-items>div div[data-v-1d0bd6ea]{line-height:1.5}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
